import type { Scene } from './types.js';
/** Render-only aliases keep an original and its prepared photo independent. */
export const designCutoutAssetId = (id: string): string => `design-cutout:${id}`;
export function resolveDesignerPhotoSources(scene: Scene, available: (id: string) => boolean): Scene {
  return { ...scene, elements: scene.elements.map(el => {
    if (el.type === 'sticker') return { ...el, value: { ...el.value, layers: el.value.layers.map(layer => {
      if (layer.kind !== 'image' || !layer.effects?.some(effect => effect.kind === 'removeBackground')) return layer;
      const id = designCutoutAssetId(layer.assetId);
      if (!available(id)) throw new Error('Background removal is not ready. Prepare the photo before confirming the Sticker.');
      return { ...layer, assetId: id };
    }) } };
    if (el.type !== 'image' || !el.effects?.some(effect => effect.kind === 'removeBackground')) return el;
    const id = el.value ?? (el.source.kind === 'static' ? el.source.assetId : undefined);
    return id && available(designCutoutAssetId(id)) ? { ...el, value: designCutoutAssetId(id) } : el;
  }) };
}
